import { render, staticRenderFns } from "./PlayerLayout.vue?vue&type=template&id=5ec93306&scoped=true"
import script from "./PlayerLayout.vue?vue&type=script&lang=js"
export * from "./PlayerLayout.vue?vue&type=script&lang=js"
import style0 from "./PlayerLayout.vue?vue&type=style&index=0&id=5ec93306&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec93306",
  null
  
)

export default component.exports